export default __webpack_public_path__ + "static/media/pt-30.30b3c12e.svg";